'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';

/**
 * Al navegar entre páginas (App Router), lleva el scroll al tope para que
 * cada página abra en su portada.
 *
 * Next hace este scroll solo, pero cuando el primer hijo del segmento es un
 * `<script type="application/ld+json">` (JSON-LD inyectado en server) toma esa
 * etiqueta —sin caja, en el tope— como "ya visible" y no hace nada, dejando el
 * scroll de la página anterior. Esto lo fuerza.
 *
 * Si el destino trae hash (`/servicios/#area`), no tocamos nada: deja que el
 * navegador haga el salto al ancla.
 */
export default function ScrollReset() {
  const pathname = usePathname();

  useEffect(() => {
    if (window.location.hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname]);

  return null;
}
